import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode, faList, faListUl, faChartLine } from '@fortawesome/free-solid-svg-icons';
import './BigData.css';
import SpiderChart from './SpiderChart';

function SpiderWebChart() {
  const [selectedTrackers, setSelectedTrackers] = useState('');

  return (
    <div>
      <div className="mt-12 flex flex-col justify-center">
        <div className='flex justify-center text-2xl text-yellow-200 mb-4 min-w-full'>Visualizing, Tracking & Improving Performance</div>
        <p className='text-white flex justify-center text-xl mb-2'>Palava Sports & Wellness Group</p>

        <div className='flex justify-center text-lg text-yellow-200 mb-4'>
          <select
              value={selectedTrackers}
              onChange={e => setSelectedTrackers(e.target.value)}
              className="bg-gray-800 text-white p-2 rounded-md mr-8"
            >
              <option value="">Select Category</option>
              <option value="timeManagement">Time Management</option>
              <option value="exerciseRoutine">Exercise Routine</option>
              <option value="mealPlanning">Meal Planning</option>
              <option value="sleepQuality">Sleep Quality</option>
              <option value="familyChores">Family Chores</option>
              <option value="screenTime">Screen Time</option>
              <option value="personalDevelopment">Personal Development</option>
              <option value="mentalHealthCheck">Mental Health Check</option>
              <option value="dailyProductivity">Daily Productivity</option>
              <option value="workLifeBalance">Work-Life Balance</option>
              <option value="budgetTracking">Budget Tracking</option>
              <option value="hydration">Hydration</option>
              <option value="nutritionBalance">Nutrition Balance</option>
              <option value="learningGoals">Learning Goals</option>
              <option value="parentingTasks">Parenting Tasks</option>
              <option value="stressManagement">Stress Management</option>
              <option value="fitnessGoals">Fitness Goals</option>
              <option value="hygieneAndHealth">Hygiene and Health</option>
              <option value="outdoorActivities">Outdoor Activities</option>
              <option value="householdMaintenance">Household Maintenance</option>
              <option value="relationshipBalance">Relationship Balance</option>
              <option value="dailyGratitude">Daily Gratitude</option>
              <option value="mindfulnessPractices">Mindfulness Practices</option>
              <option value="petCare">Pet Care</option>
              <option value="creativePursuits">Creative Pursuits</option>
            </select>
        </div>
        {/* <p className='text-white flex justify-center text-xl'>This is Sample</p> */}
        <div className="flex justify-center" style={{height:"500px", width: "500px"}}>
          {SpiderChart ()}
        </div>
      </div>
      <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>            
    </div>
  );
};

export default SpiderWebChart;
